import DarkModeSwitchEditor from "./DarkModeSwitchEditor";
import Logo from "./logo.svg";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

registerBlockType(
    'wp-dark-mode-block/dark-mode-switch',
    {
        title: __('Dark Mode Switch', 'wp-dark-mode'),
        icon: Logo,
        category: 'common',

        /**
         * Attributes
         */
        attributes: {
            style: {
                type: 'number',
                default: 1,
            },
            alignment: {
                type: 'string',
                default: 'center',
            },
            size: {
                type: 'number',
                default: 1,
            },
        },
        supports: {
            align: ['center', 'wide', 'full'],
        },

        /**
         * On Editor Load
         */
        edit: DarkModeSwitchEditor,

        /**
         * 
         * @param {object} attributes 
         * @returns JSX
         */
        save: ({ attributes }) => {
            const { alignment, style, size } = attributes;
            return (<div className="wp-dark-mode-switch wp-dark-mode-ignore" data-style={ style } data-size={ size } style={{ textAlign: alignment }} ></div>);
        },
    }
);

